import React, {useState, useEffect} from 'react'
import { Title } from '../../components/JurosCompostos/Title'
import { MoneySelect } from '../../components/JurosCompostos/MoneySelect'
import { Period } from '../../components/JurosCompostos/Period'
import { Button } from '../../components/JurosCompostos/Button'
import { Table } from '../../components/RendaFixa/Table'
import { AdvancedChart } from '../../components/RendaFixa/AdvancedChart'
import CloseIcon from './closeIcon.svg'
import styles from './index.module.css'
import { Label } from '../../components/JurosCompostos/Label'
import { Investiments } from '../../components/RendaFixa/Investiments'
import { BarChart } from '../../components/RendaFixa/BarChart'
import ApiSuno from '../../api/services/ApiSuno';
import ApiSunoProvider from '../../api/providers/ApiSuno';
import { Advanced } from './Advanced'

var moment = require('moment')

export const RendaFixa = (props) => {
    const apiSuno = new ApiSuno(ApiSunoProvider);
    const [investimento, setInvestimento] = useState(0)
    const [investimentoValid, setInvestimentoValid] = useState(true)
    const [investimentoErrorText, setInvestimentoErrorText] = useState('')
    const [acumulado, setAcumulado] = useState([])
    const [aplicacao, setAplicacao] = useState(0)
    const [aplicacaoValid, setAplicacaoValid] = useState(true)
    const [aplicacaoErrorText, setAplicacaoErrorText] = useState('')
    const [periodText, setPeriodText] = useState(0)
    const [periodSelect, setPeriodSelect] = useState(1)
    const [periodValid, setPeriodValid] = useState(true)
    const [investiments, setInvestiments] = useState([])
    const [showChartAndTable, setShowChartAndTable] = useState(false)
    const [rentabilidadeBase, setRentabilidadeBase] = useState({ipca: 10.74, cdi: 9.15})
    const [resultType, setResultType] = useState('nominal')
    const [tooltipText, setTooltipText] = useState('')
    const [rentabilidadesCalculo, setRentabilidadesCalculo] = useState({})
    const [rentabilidadesChart, setRentabilidadesChart] = useState([])
    const [showAdvanced, setShowAdvanced] = useState(false)
    const [advancedShowSelic, setAdvancedShowSelic] = useState(false)
    const [validInvestimens, setValidInvestimens] = useState(true)
    const [investimentsErrorText, setInvestimentsErrorText] = useState('Preencha esse campo.')

    /*Pega rentabilidade base da API
    useEffect(()=>{
      apiSuno.getRentabilidade('ipca',
        responseSuccess=>{
            try {
              let rent = rentabilidadeBase
              rent.ipca = somaRentabilidadeBase(responseSuccess.data.data.monthly)
              apiSuno.getRentabilidade('cdi',
              responseSuccess=>{
                  try {
                    rent.cdi = somaRentabilidadeBase(responseSuccess.data.data.monthly)
                    setRentabilidadeBase(rent)
                    setTooltipText(`Sugestão de rentabilidade:
                      <br />Selic (${(rent.cdi+0.1).toFixed(2)}% a.a.)
                      <br />IPCA (${rent.ipca.toFixed(2)}% a.a.)
                      <br />CDI (${rent.cdi.toFixed(2)}% a.a.)`)
                  } catch (error) {
                    console.log("++++++++++++++++++")
                    console.log(error)
                    console.log("++++++++++++++++++")
                    alert('Ocorreu um erro ao tentar consultar as rentabilidades!')
                  }
              },
              responseError=>{
              console.log("++++++++++++++++++")
              console.log(responseError)
              console.log("++++++++++++++++++")
              alert('Ocorreu um erro ao tentar consultar as rentabilidades!')
              })
            } catch (error) {
              console.log("++++++++++++++++++")
              console.log(error)
              console.log("++++++++++++++++++")
              alert('Ocorreu um erro ao tentar consultar as rentabilidades!')
            }
        },
        responseError=>{
        console.log("++++++++++++++++++")
        console.log(responseError)
        console.log("++++++++++++++++++")
        alert('Ocorreu um erro ao tentar consultar as rentabilidades!')
        })
    }, ['Only one'])*/

    useEffect(()=>{
      setTooltipText(`Sugestão de rentabilidade:
      <br />Selic (${(rentabilidadeBase.cdi+0.1).toFixed(2)}% a.a.)
      <br />IPCA (${rentabilidadeBase.ipca.toFixed(2)}% a.a.)
      <br />CDI (${rentabilidadeBase.cdi.toFixed(2)}% a.a.)`)
    }, [])

    const handleInvestimentoChange = (value) => {
        setInvestimentoValid(true)
        setInvestimentoErrorText('')
        setInvestimento(parseFloat(value.replaceAll('.','').replaceAll(',','.')))
        setAplicacaoValid(true)
    }

    const handleAplicacaoChange = (value) => {
        setAplicacaoValid(true)
        setAplicacaoErrorText('')
        setAplicacao(parseFloat(value.replaceAll('.','').replaceAll(',','.')))
        setInvestimentoValid(true)
    }

    const handlePeriodText = (value) => {
        setRentabilidadesChart([])
        setPeriodValid(true)
        setPeriodText(value)
    }
    const handlePeriodoSelect = (value) => {
        setRentabilidadesChart([])
        setPeriodSelect(value)
    }

    const handleInvestimets = (value) => {
      setInvestiments(value)
      setValidInvestimens(true)
    }

    const handleResultTypeChange = (value) => {
      if(resultType === 'nominal'){
        setResultType('real')
      } else {
        setResultType('nominal')
      }
    }

    const advancedButton = () => {
      if(handleCalculateButton()){
        setShowAdvanced(true)
        setShowChartAndTable(false)
      }
    }

    const checkInvestiments = () => {
      let returnValue = true
      investiments.forEach(investiment =>{
        if(investiment.rentabilitySelected.id === 1 || investiment.rentabilitySelected.id === 3 || investiment.rentabilitySelected.id === 4){
          if(investiment.rentabilityValue === 0){
            returnValue = false
          }
        }
      })
      console.log(returnValue)
      return returnValue
    }

    const handleCalculateButton = () => {
      setShowChartAndTable(false)
      if(parseFloat(investimento) === 0 && parseFloat(aplicacao) === 0){
        setInvestimentoErrorText("Preencha esse campo")
        setInvestimentoValid(false)
        setAplicacaoErrorText("Preencha esse campo")
        setAplicacaoValid(false)
      } else if(parseInt((periodText === '')?0:periodText) === 0){
        setPeriodValid(false)
      } else if(checkInvestiments() === false){
        setValidInvestimens(false)
      } else{
        let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
        let rentabilidades = []
        if(rentabilidadesChart.length === 0){
          rentabilidades = geraRentabilidades()
          setRentabilidadesCalculo(rentabilidades)
        } else {
          rentabilidades = rentabilidadesCalculo
        }
        let investimentos = getInvestimentos(rentabilidades)
        console.log(investiments)
        calculoRendaFixa(investimentos, parseFloat(investimento), parseFloat(aplicacao), period, rentabilidades)
        return true
      }
      return false
    }

    // Atualiza o valor de rentabilidade com as alerações feitas no gráfico do menu avançado
    function utualizaRentabilidades(value){
      let rentChart = Object.assign([], rentabilidadesChart)
      let rentabilidades = Object.assign([], rentabilidadesCalculo)
      let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
      if(value[0].id === 'ipca'){
        rentChart[0].data = value[0].data
      } else {
        rentChart[1].data = value[0].data.map((e, index)=>{
          if(index > 0){
            return e.y-0.1
          } else {
            return e.y
          }
        })
        rentChart[2].data = value[0].data
      }
      for (let index = 1; index < rentabilidades[value[0].id].length; index++) {
        let finalValue = value[0].data[index].y
        if(period < 36){
          if(value[0].id === 'selic'){
            rentabilidades['cdi'][index] = parseFloat(((finalValue* 12)-0.1).toFixed(2))
          }
          rentabilidades[value[0].id][index] = parseFloat((finalValue * 12).toFixed(2))
        } else {
          if(value[0].id === 'selic'){
            rentabilidades['cdi'][index] = parseFloat((finalValue-0.1).toFixed(2))
          }
          rentabilidades[value[0].id][index] = parseFloat(finalValue.toFixed(2))
        }
      }
      setRentabilidadesCalculo(rentabilidades)
      setRentabilidadesChart(rentChart)
    }

    // Soma o valor das rentabilidades mensais retornadas pela API da Suno
    function somaRentabilidadeBase(array){
      let total = 0
      for (let index = array.length-1; index > array.length-13; index--) {
        total += array[index].value
      }
      return parseFloat(total.toFixed(2))
    }

    function getInvestimentos(rentabilidadeBase){
      let hasSelic = false
      let investimentos = []
      let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
      let periodControler = controlePeriodo(period, 0, true)
      if(period % periodControler > 0){
        period = parseInt(period / periodControler)+1
      } else {
        period = parseInt(period / periodControler)
      }
      /*if((parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)) >= 36){
        period++;
      }*/
      investiments.forEach(investiment=>{
        let rent = []
        if(!hasSelic && (investiment.rentabilitySelected.id === 1 || investiment.rentabilitySelected.id === 4)){
          hasSelic = true
        }
        for (let index = 0; index < period; index++) {
          let value = 0
          if(investiment.rentabilitySelected.id === 1){
            value = Math.pow((1+(((rentabilidadeBase.selic[index]).toFixed(2) * (investiment.rentabilityValue/100))/100)),(1/12))-1
          } else if(investiment.rentabilitySelected.id === 2){
            value = Math.pow((1+((rentabilidadeBase.ipca[index] + investiment.rentabilityValue)/100)),(1/12))-1
          } else if(investiment.rentabilitySelected.id === 3){
            value = Math.pow((1+investiment.rentabilityValue/100),(1/12))-1
          } else if(investiment.rentabilitySelected.id === 4){
            value = Math.pow((1+((rentabilidadeBase.cdi[index] * (investiment.rentabilityValue/100))/100)),(1/12))-1
          }
          rent.push(value)
        }
        investimentos.push(rent)
      })
      setAdvancedShowSelic(hasSelic)
      return investimentos
    }

    function geraRentabilidades(){
      let rentabilidades = {
        ipca: [],
        cdi: [],
        selic: []
      }
      let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
      let periodControler = controlePeriodo(period, 0, true)
      if(period % periodControler > 0){
        period = parseInt(period / periodControler)+1
      } else {
        period = parseInt(period / periodControler)
      }
      for (let index = 0; index < period; index++) {
        rentabilidades.ipca.push(rentabilidadeBase.ipca)
        rentabilidades.cdi.push(rentabilidadeBase.cdi)
        rentabilidades.selic.push(rentabilidadeBase.cdi+0.1)
      }
      // Gerar rentabilidade exibida no grafico do menu avançado
      let data = moment()
      let chartCount = 0
      let investimentoChart = [{"id": "ipca",
        "data": []
      },
      {"id": "cdi",
        "data": []
      },
      {"id": "selic",
        "data": []
      }]
      period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
      for (let index = 0; index < period; index++) {
        if(chartCount === index){
          // Se maior que 36 exibe a rentabilidade por ano, caso contratio exibe a rentabilidade por mês
          if(period >= 36){
            investimentoChart[0].data.push({"x": dateFormat(period, data), "y": rentabilidadeBase.ipca})
            investimentoChart[1].data.push({"x": dateFormat(period, data), "y": rentabilidadeBase.cdi})
            investimentoChart[2].data.push({"x": dateFormat(period, data), "y": rentabilidadeBase.cdi+0.1})
          } else {
            investimentoChart[0].data.push({"x": dateFormat(period, data), "y": parseFloat((rentabilidadeBase.ipca/12).toFixed(2))})
            investimentoChart[1].data.push({"x": dateFormat(period, data), "y": parseFloat((rentabilidadeBase.cdi/12).toFixed(2))})
            investimentoChart[2].data.push({"x": dateFormat(period, data), "y": parseFloat(((rentabilidadeBase.cdi+0.1)/12).toFixed(2))})
          }
          chartCount = controlePeriodo(period, chartCount, true)
        }
        data = moment(data).add(1,'M')
      }
      setRentabilidadesChart(investimentoChart)
      return rentabilidades
    }

    function getImposto(periodo){
      let today = moment()
      let days = today.diff(moment(today).add(periodo,'M'), 'days') * (-1)
      if(days <= 180){
        return 22.5
      }
      if(days <= 360){
        return 20
      }
      if(days <= 720){
        return 17.5
      }
      if(days > 720){
        return 15
      }
    }

    function calculoRendaFixa(investimentos, investimentoInic, aportes, periodo, rentabilidades){
        let data = moment()
        let total = []
        let inflacao = 0
        let chartCount = controlePeriodo(periodo, 0, false)
        let rentCount = 0
        for (let index = 0; index < investimentos.length; index++) {
          total.push(investimentoInic)
        }
        for (let count = 1; count <= periodo; count++) {
          data = moment(data).add(1,'M')
          inflacao += rentabilidades.ipca[rentCount]/12
          for (let index = 0; index < investimentos.length; index++) {
            total[index] = (total[index] * (1+(investimentos[index][rentCount]))) + aportes
          }
          if(count === chartCount){
            chartCount = controlePeriodo(periodo, chartCount, false)
            if(rentCount+1 <= investimentos[0].length-1){
              rentCount++
            }
          }
        }

        let newAcumulado = []
        for (let index = 0; index < investiments.length; index++) {
          newAcumulado.push({
            investimentType: investiments[index].investimentTypeSelected.label,
            rentability: investiments[index].rentabilitySelected.label,
            value: total[index],
            alImposto: (investiments[index].investimentTypeSelected.tax)?getImposto(periodo):0,
            inflacao: inflacao})
        }
        setAcumulado(newAcumulado)
        return total
    }

    // Função utilizada para controlar por periodo os dados que seram exibidos no gráfico
    function controlePeriodo(periodo, value, isJuros){
      let data = moment()
      if(periodo <= 24){
        value += 3
      } else if(periodo < 36){
        value += 6
      } else if(periodo <= 144){
        if(value === 0 && !isJuros){
          value = 12 - parseInt(data.format('M'))
        } else {
          value += 12
        }
      } else{
        if(value === 0 && !isJuros){
          value = 12 - parseInt(data.format('M'))
        } else {
          value += (parseInt(parseInt(periodText)/12) * 2) * 12
        }
      }
      if(value > periodo){
        value = periodo
      }
      return value
    }

    function dateFormat(periodo, date){
      if(periodo >= 36){
        return moment(date).format('YYYY')
      } else{
        return moment(date).format('MMM YYYY')
      }
    }

    function calculaValorInvestido(){
      let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
      return investimento + (aplicacao * period)
    }

    return (
        <div className={styles.main}>
          <div className={styles.calculator} style={(showAdvanced)?{}:{display:'none'}}>
            {(showAdvanced)?<Advanced
              cancelButton={()=>{setShowAdvanced(false)}}
              calculateButton={()=>{setShowAdvanced(false); handleCalculateButton(); setShowChartAndTable(true)}}
              rentabilidades={rentabilidadesCalculo}
              rentabilidadesChart={rentabilidadesChart}
              period={parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)}
              utualizaRentabilidades={utualizaRentabilidades}
              showSelic={advancedShowSelic}
              handleSwitchOnClick={handleResultTypeChange}
              resultType={resultType}
            />
            :null}
          </div>
          <div className={styles.calculator} style={(showChartAndTable)?{borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px'}:{},((window.screen.width <= 768 && showChartAndTable) || showAdvanced)?{display:'none'}:{}}>
            <Title>Simule as rendas fixas:</Title>
            <div className={styles.rendaFixaCalculatorFields}>
              <div className={styles.params}>
                  <div className={styles.paramsfield}>
                    <MoneySelect
                        min={0}
                        max={2000}
                        maxValueAllow={999999.99}
                        initial={investimento}
                        label='Investimento inicial'
                        onChange={handleInvestimentoChange}
                        valid={investimentoValid}
                        errorMessage={investimentoErrorText}
                    />
                  </div>
                  <div className={styles.paramsfield}>
                    <MoneySelect
                        min={0}
                        max={400}
                        maxValueAllow={999999.99}
                        initial={aplicacao}
                        label='Aplicação Mensal'
                        onChange={handleAplicacaoChange}
                        valid={aplicacaoValid}
                        errorMessage={aplicacaoErrorText}
                    />
                  </div>
                  <div className={styles.paramsfield}>
                    <Period
                        label='Período'
                        onChangeText={handlePeriodText}
                        onChangeSelect={handlePeriodoSelect}
                        valueText={periodText}
                        valueSelect={periodSelect}
                        valid={periodValid}
                    />
                  </div>
              </div>
              <div className={styles.label}>
                Inclua seus investimentos em até 3 linhas e compare as rentabilidades
              </div>
              <div className={styles.investiments}>
                <div>
                  <Label tooltip={false}>{(window.screen.width > 768)?"Selecione o tipo de renda fixa":"Qual tipo?"}</Label>
                </div>
                <div className={styles.investimentsRentabilit}>
                  <Label tooltip={true} tooltipText={tooltipText}>Rentabilidade</Label>
                </div>
              </div>
              <Investiments onChange={handleInvestimets} advancedButton={advancedButton} valid={validInvestimens} errorMessage={investimentsErrorText}/>
            </div>
            <div>
              <Button onClick={()=>{(handleCalculateButton())?setShowChartAndTable(true):null}}>CALCULAR</Button>
            </div>
          </div>
          {(showChartAndTable)?
            <div className={styles.chartAndTable}>
              <div className={styles.titleRow}>
                <Title color='#fff'>Simulação de rentabilidade </Title>
                {(window.screen.width <= 768)?
                  <div onClick={()=>{setShowChartAndTable(false)}}>
                    <CloseIcon fill="white"/>
                  </div>
                :null}
              </div>
              <Table type={resultType} investido={calculaValorInvestido()} acumulado={acumulado}/>
              <BarChart type={resultType} investido={calculaValorInvestido()} acumulado={acumulado}/>
            </div>
          :null}
        </div>
    )
}
